import { useTranslation } from "react-i18next";

import { Icon } from "simplydo/react/ui";

import { useAppSelector } from "store";
import util from "utils/utils";

import { MfaSettingsSection } from "../Mfa/MfaSettingsSection";

const EnforceMFA = () => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.user);
  const org = user?.ownerOrganisation;

  if (user && util.hasSetUpMFA(user, org)) {
    return null;
  }

  return (
    <>
      <h3>
        <Icon name="lock" style={{ paddingRight: "10px" }} />
        {t("entry.mfa.title")} {t("generic.required")}
      </h3>
      <p>
        {t("entry.mfa.requiredByOrg", {
          orgName: user?.ownerOrganisation?.name,
        })}
      </p>
      <p>{t("entry.mfa.enforcementInfo")}</p>

      <MfaSettingsSection mfaEnforced />
    </>
  );
};

export default EnforceMFA;
